<template>
	<calculate-component :current="currentStep" :hasResult="hasResult">
		<!-- 侧边内容 -->
		<template #side>
			<a-form
				:model="formState"
				name="basic"
				style="width: 100%"
				ref="formRef"
				layout="vertical"
				autocomplete="off"
			>
				<div class="primary-title w2">
					储能基本信息
					<div class="primary-title-line"></div>
				</div>
				<a-row :gutter="12">
					<a-col :span="12">
						<a-form-item
							label="放电深度"
							name="dod"
							:rules="[
								{
									required: true,
									message: '请输入放电深度',
								},
							]"
						>
							<a-input
								placeholder="请输入放电深度"
								v-model:value="formState.dod"
								@change="integerInput('dod')"
								:disabled="inputDisabled"
								size="large"
							>
								<template #suffix>%</template>
							</a-input>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item
							label="综合效率"
							name="efficiency"
							:rules="[
								{
									required: true,
									message: '请输入综合效率',
								},
							]"
						>
							<a-input
								placeholder="请输入综合效率"
								v-model:value="formState.efficiency"
								@change="integerInput('efficiency')"
								:disabled="inputDisabled"
								size="large"
							>
								<template #suffix>%</template>
							</a-input>
						</a-form-item>
					</a-col>
					<a-col :span="24">
						<a-form-item
							label="需量限制"
							name="demandLimit"
							:rules="[
								{
									required: true,
									message: '请输入需量限制',
								},
							]"
						>
							<a-input
								placeholder="请输入需量限制"
								v-model:value="formState.demandLimit"
								@input="inputChange('demandLimit', 2)"
								@blur="blur('demandLimit')"
								:disabled="inputDisabled"
								size="large"
							>
								<template #suffix>kW</template>
							</a-input>
						</a-form-item>
					</a-col>
					<a-col :span="24">
						<a-form-item
							label="规模粒度"
							:rules="[
								{
									required: true,
									message: '请输入完整规模粒度',
								},
							]"
							name="granularity"
						>
							<div class="line" style="margin-bottom: 4px">
								<div class="font font-left">从</div>
								<a-input
									v-model:value="granularity.initPower"
									suffix="kW"
									size="large"
									@change="checkGranularity"
									@input="
										inputGranularityChange('initPower', 2)
									"
									@blur="granularityBlur('initPower')"
									:disabled="inputDisabled"
								></a-input>
								<a-input
									v-model:value="granularity.initCapacity"
									suffix="kWh"
									size="large"
									@change="checkGranularity"
									@input="
										inputGranularityChange(
											'initCapacity',
											2
										)
									"
									@blur="granularityBlur('initCapacity')"
									:disabled="inputDisabled"
								></a-input>
								<div class="font font-right">开始</div>
							</div>
							<div class="line" style="margin-bottom: 4px">
								<div class="font font-left">按</div>
								<a-input
									v-model:value="granularity.periodPower"
									suffix="kW"
									size="large"
									@change="checkGranularity"
									:disabled="inputDisabled"
									@input="
										inputGranularityChange('periodPower', 2)
									"
									@blur="granularityBlur('periodPower')"
								></a-input>
								<a-input
									v-model:value="granularity.periodCapacity"
									suffix="kWh"
									size="large"
									@change="checkGranularity"
									:disabled="inputDisabled"
									@input="
										inputGranularityChange(
											'periodCapacity',
											2
										)
									"
									@blur="granularityBlur('periodCapacity')"
								></a-input>
								<div class="font font-right">叠加</div>
							</div>
							<div class="line">
								<div class="font line-font">最多叠加</div>
								<a-input
									v-model:value="granularity.maxTimes"
									suffix="次"
									size="large"
									@change="checkGranularity"
									:disabled="inputDisabled"
									@input="integerCondition('maxTimes', 1, 20)"
								></a-input>
							</div>
						</a-form-item>
					</a-col>
				</a-row>
				<div class="primary-title w3">
					<div class="font">
						电价、时段、策略
						<a-tooltip
							placement="right"
							:overlayStyle="{
								width: '218px',
							}"
						>
							<template #title>
								模拟计算时到达DOD限制即停止充放，不会超过SOC
							</template>
							<span class="tooltip-cion"><InfoOutlined /></span>
						</a-tooltip>
					</div>
					<div class="primary-title-line"></div>
				</div>
				<div class="">
					<price-strategy
						:defaultStrategyData="defaultStrategyData"
						:disabled="inputDisabled"
						:strategyData="strategyData"
						ref="strategyRef"
					></price-strategy>
				</div>
			</a-form>

			<a-button
				type="primary"
				class="bottom-btn"
				:loading="status == 1 || status == 1.5"
				@click="startAnalysis()"
				:disabled="inputDisabled"
				style="width: 100%"
				v-if="[0, 1, 1.5].includes(status)"
			>
				<span>
					{{
						status === 0
							? "开始配储评估"
							: status === 1
							? `配储评估中 ${percent}%`
							: status === 1.5
							? `配储评估中 ${percent}%`
							: "-"
					}}
				</span>
			</a-button>
			<a-button
				type="primary"
				class="bottom-btn"
				:loading="status == 1 || status == 1.5"
				@click="startAnalysis(schemeId)"
				style="width: 100%"
				:disabled="inputDisabled"
				v-if="[2, 3].includes(status)"
			>
				重新开始配储评估
			</a-button>
		</template>
		<template #content>
			<div class="primary-title">
				<div class="title-left">
					<div class="font">
						配储评估结果
						<div class="icon">
							<a-tooltip
								:overlayStyle="{
									whiteSpace: 'nowrap',
									maxWidth: 'none',
								}"
								placement="right"
							>
								<template #title>
									<div>
										储能日均收益 = 统计时间内总收益（元） /
										天数
									</div>
									<div>
										单位容量日均收益 = 储能日均收益（元/天）
										/ 装机容量（kWh）
									</div>
								</template>
								<span class="tooltip-cion">
									<InfoOutlined />
								</span>
							</a-tooltip>
						</div>
					</div>
					<div class="primary-title-line"></div>
				</div>
				<div class="title-right" v-if="showTips">
					<div class="doing-tips" v-if="status == 1.5">
						<span class="left-icon"><LoadingOutlined /></span>
						配储评估进行中，当前进度{{ percent }}%

						<span
							class="right-icon"
							@click="() => (showTips = !showTips)"
							v-if="status != 1.5 || currentStep == 1.5"
						>
							<CloseOutlined />
						</span>
					</div>
					<!-- 分析中 -->
					<div class="succcess-tips" v-if="status == 2">
						<span class="left-icon">
							<img
								src="@/assets/images/success-icon.png"
								alt=""
							/>
						</span>
						配储评估已完成，点击右上角“下一步”按钮，进行经济分析
						<span
							class="right-icon"
							@click="() => (showTips = !showTips)"
						>
							<CloseOutlined />
						</span>
					</div>
					<!-- 分析失败 -->
					<div class="error-tips" v-if="status == 3">
						<span class="left-icon">
							<img src="@/assets/images/fail-icon.png" alt="" />
						</span>
						{{ errorMsg }}
					</div>
				</div>
			</div>
			<!-- 未开始 -->
			<div v-if="status == 0" class="status-img">
				<img src="@/assets/images/empty_3.png" alt="" />
				<div class="info">
					<div class="info-title">暂无结果</div>
					<div class="second-title">
						请先完成左侧内容填写，并进行配储评估
					</div>
				</div>
			</div>
			<!-- 进行中 -->
			<div v-if="status == 1" class="status-img">
				<!-- 动画区域 -->
				<div id="svgaA" class="svga"></div>
				<div class="info">
					<div class="load-title">配储评估中</div>
				</div>
			</div>
			<!-- 部分已完成 || 已完成 -->
			<div class="result" v-if="status > 1">
				<div v-if="currentStep != 1.3">
					<div class="finish beautify_scroll">
						<div class="inner-box" style="margin-bottom: 40px">
							<div class="echarts-title">日均收益</div>
							<echarts-component
								style="height: 280px; margin-bottom: 24px"
								:options="dayAverageOptions"
							></echarts-component>
							<div class="echarts-title">单位容量日均收益</div>
							<echarts-component
								style="height: 280px"
								:options="unitDayAverageOptions"
							></echarts-component>

							<!-- v1新增表格 -->
							<income-detail-table
								:averageDatas="averageDatas"
							></income-detail-table>
						</div>

						<div class="inner-box no-padding">
							<!-- 详细内容区 -->
							<div class="detail">
								<div
									v-if="recommendData.finish"
									class="detailContent"
								>
									<img
										src="@/assets/images/lineicon.png"
										alt=""
										class="addicon"
									/>
									<div
										class="recommended tips"
										v-if="recommendData.data != null"
									>
										<div>推荐配置：</div>
										<div>
											{{ recommendData.data.capacity }}
											kWh
										</div>
										<div
											class="action"
											@click="
												capacityChange(
													recommendData.data.jobId
												)
											"
										>
											查看推荐
										</div>
									</div>
									<div v-else>
										<div class="tips">
											配储效果不佳，不建议配储
										</div>
									</div>
								</div>
								<div class="recommended" v-else></div>
								<div class="bottom-content">
									<div class="detail-header">
										<span class="font">
											选择容量查看详情：
										</span>
										<a-select
											:value="capacityState.capacity"
											style="
												width: 240px;
												margin-right: 8px;
											"
											placeholder="请选择容量"
											@change="capacityChange"
											size="large"
											:getPopupContainer="
												triggerNode =>
													triggerNode.parentNode
											"
										>
											<a-select-option
												v-for="(
													item, index
												) in capacityList"
												:key="index"
												:value="item.id"
											>
												{{ item.capacity }}kWh
											</a-select-option>
										</a-select>
										<a-select
											:value="capacityState.tactics"
											style="width: 240px"
											placeholder="请选择策略"
											@change="tacticsChange"
											size="large"
											:getPopupContainer="
												triggerNode =>
													triggerNode.parentNode
											"
										>
											<a-select-option value="prev">
												固定策略
											</a-select-option>
											<a-select-option value="wise">
												智能策略
											</a-select-option>
										</a-select>
									</div>

									<div class="detail-box">
										<div class="info">
											<div class="info-box">
												<img
													src="@/assets/images/days-icon.png"
													alt=""
												/>
												有效数据：
												<div class="count">
													{{
														detailData.days || "-"
													}}天
												</div>
											</div>
											<div class="split-line"></div>
											<div class="info-box">
												<img
													src="@/assets/images/loop.png"
													alt=""
												/>
												日均循环次数：
												<div class="count">
													{{
														detailData.timesDayMean ||
														"-"
													}}次
												</div>
												<a-tooltip placement="right">
													<template #title>
														日均循环次数=(总放电量/装机容量)/有效天数
													</template>
													<span class="tooltip-cion">
														<InfoOutlined />
													</span>
												</a-tooltip>
											</div>
										</div>
										<div class="presentation-box">
											<div
												class="info-boxs"
												v-for="(
													present, index
												) in presentData"
												:key="index"
											>
												<div
													v-for="(
														item, index
													) in present.arr"
													:key="index"
													class="in-box"
												>
													<div class="in-box-top">
														{{ item.title }}
													</div>
													<div class="in-box-bottom">
														{{
															presentDataObjects[
																item.value
															] || "-"
														}}
														{{ item.unit }}
													</div>
												</div>
											</div>
										</div>

										<div class="echarts-top">
											<div class="echarts-title">
												典型日负荷配储前后功率对比
											</div>
											<a-select
												placeholder="请选择"
												v-model:value="
													capacityState.load
												"
												style="width: 250px"
												@change="loadChange"
												:getPopupContainer="
													triggerNode =>
														triggerNode.parentNode
												"
											>
												<a-select-option
													v-for="(
														item, index
													) in loadList"
													:key="index"
													:value="item.value"
												>
													{{ item.name }}
												</a-select-option>
											</a-select>
										</div>
										<div>
											<a-row :gutter="12">
												<a-col
													:span="24"
													style="margin-bottom: 8px"
												>
													<!-- 总表有功功率 -->
													<echarts-component
														style="
															height: 280px;
															margin-bottom: 24px;
														"
														:options="powerOptions"
													></echarts-component>
												</a-col>
												<a-col :span="12">
													<div class="echarts-title">
														总尖峰平谷电量对比
													</div>
													<echarts-component
														style="height: 280px"
														:options="
															electricOptions
														"
													></echarts-component>
												</a-col>
												<a-col :span="12">
													<div class="echarts-title">
														总尖峰平谷电费对比
													</div>
													<echarts-component
														style="height: 280px"
														:options="
															electricCostOptions
														"
													></echarts-component>
												</a-col>
											</a-row>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="status-img">
					<img src="@/assets/images/empty_3.png" alt="" />
					<div class="info">
						<div class="info-title">暂无数据</div>
						<div class="second-title">
							{{ errorMsg }}
						</div>
					</div>
				</div>
			</div>
			<!-- 失败 -->
		</template>
		<!-- 功能按钮 -->
		<template #action-btn>
			<a-button @click="nextClick" :disabled="status != 2" type="primary">
				下一步
			</a-button>
			<!-- @click="nextClick" -->
			<!-- <a-button
				v-if="status != 3"
				:disabled="status != 2"
				type="primary"
				@click="confirm"
				>生成报告</a-button
			> -->
		</template>
	</calculate-component>
</template>

<script setup>
import {onMounted, onBeforeUnmount, reactive, ref} from "vue";
import {
	InfoOutlined,
	LoadingOutlined,
	CloseOutlined,
} from "@ant-design/icons-vue";
import CalculateComponent from "../../components/CalculateBox.vue";
import IncomeDetailTable from "../../components/IncomeDetailTable.vue";
import EchartsComponent from "@/components/EchartsComponent.vue";
import PriceStrategy from "./components/PriceStrategy.vue";

import {toFixed, defaultOptions, setNotOpt, map} from "@/plugins/index.js";
import {message} from "ant-design-vue";
// 引入router
import {useRoute, useRouter} from "vue-router";
const route = useRoute();
const router = useRouter();
// 引入vuex
import {useStore} from "vuex";
const store = useStore();
// 引入动画库
import {Player as SVGAPlayer, Parser as SVGAParser} from "svgaplayerweb";
import {processingData, mackElecOptios} from "../../plugin";
// 接口api
import {
	startEsAnalysis,
	getScheduleData,
	getAnalysisResult,
	getCapacityList,
	getCapacityDetail,
	getDefaultPriceStrategyTemplate,
	saveScemeStep,
	getRecommend,
} from "@/api/scheme.js";
import {getProjectDetail} from "@/api/projects";
// 引入解密 & 加密
import {decryptData, encryptData} from "@/plugins/index.js";

// 记录下id
const loadId = ref(null);

// 记录下配储id
const schemeId = ref(null);

const inputDisabled = ref(true); // 默认不可选

const currentStep = ref(1);

// 策略模板数据
const strategyData = ref(null);

// 默认模板数据
const defaultStrategyData = ref(null);

const strategyRef = ref();

// 动画
let parser = null;

let player = null;

// 记录结果
let hasResult = ref(false);

// 是否显示tips
let showTips = ref(true);

// let map = {
// 	sharp: "尖",
// 	peak: "峰",
// 	flat: "平",
// 	valley: "谷",
// 	ravine: "深谷",
// };

// 表单数据
const formState = reactive({
	dod: 90,
	efficiency: 85,
	demandLimit: undefined,
	granularity: true, // 规模粒度校验, 默认情况允许通过校验
});
const formRef = ref();

// 规模粒度数据
const granularity = reactive({
	initPower: 100,
	initCapacity: 200,
	periodPower: 100,
	periodCapacity: 200,
	maxTimes: 10,
});

// 容量详情数据
const capacityState = reactive({
	capacity: undefined,
	tactics: "prev",
	load: undefined,

	totalData: {},
});
const capacityList = ref([]);
const loadList = ref([]);

// 状态
const status = ref(0);

// 记录完成的套数
const currentFinishSize = ref(0);

// 分析进度
const percent = ref(0);

// 记录当前是否允许修改
const projectFlag = ref(null);

// 记录轮询id
const travelId = ref(null);

// 详情数据
const detailData = reactive({
	benefitTotal: null,
	timesDayMean: null,
	days: null,
});

// 记录推荐值信息
const recommendData = ref({finish: false, data: null});

// 分析失败信息
const errorMsg = ref("分析失败！");

// 日均收益
const dayAverageOptions = ref({});

// 单位日均收益
const unitDayAverageOptions = ref({});

// 收益数据
const averageDatas = ref(null);

// 总表有功功率
const powerOptions = ref({});

// 电量对比
const electricOptions = ref({});

// 电费对比
const electricCostOptions = ref({});

//  统计数据
const presentData = ref([
	{
		arr: [
			{
				title: "总充电量",
				value: "elecChargeTotal",
				unit: "MWh",
			},
			{
				title: "日均充电量",
				value: "elecChargeDayMean",
				unit: "kWh",
			},
			{
				title: "总放电量",
				value: "elecDischargeTotal",
				unit: "MWh",
			},
			{
				title: "日均放电量",
				value: "elecDischargeDayMean",
				unit: "kWh",
			},
			{
				title: "总充电成本",
				value: "chargeCostTotal",
				unit: "元",
			},
		],
	},
	{
		arr: [
			{
				title: "日均充电成本",
				value: "chargeCostDayMean",
				unit: "元/天",
			},
			{
				title: "总放电收益",
				value: "dischargeIncomeTotal",
				unit: "元",
			},
			{
				title: "日均放电收益",
				value: "dischargeIncomeDayMean",
				unit: "元/天",
			},
			{
				title: "总收益",
				value: "benefitTotal",
				unit: "元",
			},
			{
				title: "日均收益",
				value: "benefitDayMean",
				unit: "元/天",
			},
		],
	},
]);

let presentDataObjects = ref({});

onBeforeUnmount(() => {
	clearInterval(travelId.value);
	travelId.value = undefined;

	store.commit("updateBreadCrumbInfo", null);
});

onMounted(() => {
	const {id, tfmCapacity, step, updateFlag} = route.query;

	if (id) {
		loadId.value = decryptData(id) || null;
	}

	// 记录当前是否允许修改
	if (updateFlag) {
		projectFlag.value = decryptData(updateFlag);
	}

	if (tfmCapacity) {
		formState.demandLimit = decryptData(tfmCapacity);
	}

	store.commit("updateBreadCrumbInfo", {});

	/* 获取策略示例 */

	// 获取默认策略模板
	getTemplate();
	// getTacticsDemos();
	// 获取详情
	getProjectDetailData(decryptData(step ? step : ""));
});

// 获取默认策略模板
const getTemplate = () => {
	getDefaultPriceStrategyTemplate(loadId.value).then(res => {
		console.log("res:", res);
		defaultStrategyData.value = res;
	});
};

// 开始配储评估
const startAnalysis = (id = null) => {
	hasResult.value = false;
	// 校验表单
	formRef.value.validate().then(data => {
		const paramInfo = strategyRef.value.getPriceStrategy();
		console.log("infos:", paramInfo);
		// 状态修改为分析中
		status.value = 1;
		averageDatas.value = [];

		// 清空数据
		dayAverageOptions.value = {};
		unitDayAverageOptions.value = {};
		averageDatas.value = {};
		detailData.benefitTotal = "-";
		detailData.timesDayMean = "-";
		detailData.days = "-";
		presentDataObjects.value = {};
		powerOptions.value = {};
		electricOptions.value = {};
		electricCostOptions.value = {};

		recommendData.value = {finish: false, data: null};

		// 禁止修改任何参数
		updateInputDisableStatus(true);
		// inputDisabled.value = true;
		currentStep.value = 1;
		// 更新store中的项目步骤
		store.commit("updateProjectStep", 1);
		setTimeout(() => {
			startAnimation();
		}, 100);
		let send = {
			id,
			projectId: loadId.value,
			...formState,
			...granularity,
			paramInfo,
			maxTimes: granularity.maxTimes ? granularity.maxTimes : 0,
		};
		delete send.step;
		delete send.analysisMsg;
		delete send.granularity;
		delete send.jobStepVO;
		delete send.status;
		delete send.createTime;
		delete send.updateTime;

		startEsAnalysis(send)
			.then(res => {
				// 存储配储id
				schemeId.value = res;
				console.log("schemeId为：", schemeId.value);

				// 更新vuex中项目信息
				store.commit("updateProjectInfo", {
					id: loadId.value,
					step: 2,
				});
				// 获取进度 -- 加轮询
				startSearchData();
				travelId.value = setInterval(() => {
					startSearchData();
				}, 3000);
			})
			.catch(err => {
				console.log(err);
			});
	});
};

// 获取分析进度
const getSchedule = () => {
	getScheduleData(loadId.value).then(res => {
		console.log("获取分析进度", res);
		const {errorFlag, process, finishSize, analysisMsg} = res;
		if (errorFlag) {
			// 报错
			status.value = 3;
			currentStep.value = 1.3;
			hasResult.value = false;
			// 更新store中的项目步骤
			store.commit("updateProjectStep", 1.3);
			errorMsg.value = analysisMsg;
			message.error(analysisMsg);
			clearInterval(travelId.value);
			travelId.value = null;
			// 允许修改参数
			updateInputDisableStatus(false);
			// inputDisabled.value = false;
			// hasResult.value = true;
			setTimeout(() => {
				let emptyOption = setNotOpt();
				// prevOptions.value = emptyOption;
				// wiseOptions.value = emptyOption;
				dayAverageOptions.value = emptyOption;
				unitDayAverageOptions.value = emptyOption;
				powerOptions.value = emptyOption;
				electricOptions.value = emptyOption;
				electricCostOptions.value = emptyOption;
			}, 100);
		} else {
			percent.value = process;
			// 校验当前完成的套数是否跟之前一致
			if (currentFinishSize.value != finishSize) {
				if (finishSize != 0) {
					// 销毁动画
					player.clear();
					status.value = 1.5; // 部分完成
					hasResult.value = true;
				}
				currentFinishSize.value = finishSize;
				// 获取分析结果
				getAnalysisResultData();
				// 查询分套列表
				getCapacityListData();
			}
			if (process == 100) {
				status.value = 2;
				currentStep.value = 1.5;
				// 查询推荐配置
				console.log("执行了查询");
				getRecommendId();
				// 更新store中的项目步骤
				store.commit("updateProjectStep", 1.5);
				clearInterval(travelId.value);
				travelId.value = null;
				// 允许修改参数
				updateInputDisableStatus(false);
				// inputDisabled.value = false;
			}
		}
	});
};

// 获取分析结果
const getAnalysisResultData = () => {
	getAnalysisResult(loadId.value).then(res => {
		if (res) {
			const {dayProfit, unitCapacityDayProfit} = res;
			averageDatas.value = res;
			// 日均收益
			dayAverageOptions.value = processingData(dayProfit, "元/天", 2);
			console.log(dayAverageOptions.value);
			// 单位容量日均收益
			let unitDayOpt = processingData(
				unitCapacityDayProfit,
				"元/(天·kWh)",
				4
			);
			unitDayOpt.yAxis.nameTextStyle.padding = [0, 0, 5, 0];
			unitDayAverageOptions.value = unitDayOpt;
		}
	});
};

// 查询推荐配置
const getRecommendId = () => {
	getRecommend(loadId.value).then(res => {
		console.log("结果为：", res);
		recommendData.value = {
			finish: true,
			data: res,
		};
		if (res) {
			// 触发推荐值
			capacityChange(res.jobId);
		}
	});
};

// 查询分套列表
const getCapacityListData = () => {
	getCapacityList(loadId.value).then(res => {
		capacityList.value = res;
		if (res.length > 0 && recommendData.value.data == null) {
			capacityState.capacity = res[0].id;

			// 获取容量详情
			getCapacityDetailData();
		}
	});
};

// 分套容量变化
const capacityChange = val => {
	capacityState.tactics = "prev";
	capacityState.load = undefined;
	capacityState.capacity = val;
	getCapacityDetailData();
};

// 策略修改
const tacticsChange = val => {
	capacityState.tactics = val;
	capacityState.load = undefined;
	mackDetailData();
};

// 负荷修改
const loadChange = val => {
	capacityState.load = val;
	mackDetailData("load");
};

// 获取容量详情
const getCapacityDetailData = () => {
	getCapacityDetail(capacityState.capacity).then(res => {
		capacityState.totalData = res;

		mackDetailData();
	});
};

// 开启轮询
const startSearchData = () => {
	// 获取分析进度
	getSchedule();
};

// 校验规模粒度数据
const checkGranularity = () => {
	let final = true;
	Object.keys(granularity).map(key => {
		if (granularity[key] == "") {
			final = false;
		}
	});
	formState.granularity = final ? true : undefined;
};

// 规模粒度
const integerCondition = (key = "", greater = 1, less = 20) => {
	let val = granularity.maxTimes;

	// 移除非数字字符
	val = val.replace(/\D/g, "");

	// 限制范围在1到20之间
	const value = parseInt(val);

	if (isNaN(value) || value < greater) {
		val = "";
	} else if (value > less) {
		val = less.toString();
	} else {
		val = value.toString();
	}

	console.log(val);
	if (val == "") {
		formState.granularity = undefined;
	}

	granularity.maxTimes = val;
};

// 查询项目详情
const getProjectDetailData = (step = null) => {
	getProjectDetail({
		id: loadId.value,
		toStep: step ? Number(step) : null,
	}).then(res => {
		const {analysisDetailVO, step, name, id} = res;

		// 更新store中的breadcrumb信息
		store.commit("updateBreadCrumbInfo", {
			name,
		});
		// 禁止修改参数
		// inputDisabled.value = true;
		updateInputDisableStatus(true);
		if (analysisDetailVO) {
			status.value = 1; // 分析进行中
			const {id} = analysisDetailVO;
			schemeId.value = id;
			console.log("另外schemeId为：", schemeId.value);
			setTimeout(() => {
				startAnimation();
			}, 100);
			Object.keys(analysisDetailVO).map(key => {
				formState[key] = analysisDetailVO[key];
			});
			const {step, jobStepVO, paramInfo} = analysisDetailVO;
			if (jobStepVO) {
				const {
					initPower,
					initCapacity,
					periodPower,
					periodCapacity,
					maxTimes,
				} = jobStepVO;
				granularity.initPower = initPower;
				granularity.initCapacity = initCapacity;
				granularity.periodPower = periodPower;
				granularity.periodCapacity = periodCapacity;
				granularity.maxTimes = maxTimes;
				formState.granularity = true;
			} else {
				granularity.initPower = undefined;
				granularity.initCapacity = undefined;
				granularity.periodPower = undefined;
				granularity.periodCapacity = undefined;
				granularity.maxTimes = undefined;
				formState.granularity = undefined;
			}

			if (paramInfo) {
				console.log("paramInfo", paramInfo);
				strategyData.value = paramInfo;
			}

			// 算法分析失败
			if (step == 2) {
				// message.warning("算法分析失败");
				status.value = 3; // 分析失败
				currentStep.value = 1.3;
				hasResult.value = false;
				// 更新store中的项目步骤
				store.commit("updateProjectStep", 1.3);
				errorMsg.value = analysisDetailVO.analysisMsg;
				getSchedule();
			} else {
				// 获取进度 -- 加轮询
				console.log("获取进度 -- 加轮询");
				startSearchData();
				travelId.value = setInterval(() => {
					startSearchData();
				}, 3000);
			}
		} else {
			// // 获取默认策略模板
			// getTemplate();
			// 不存在
			status.value = 0; // 分析未开始
			// 允许修改参数
			updateInputDisableStatus(false);
			// inputDisabled.value = false;
		}
	});
};
// 下一步
let nextClick = () => {
	// 获取当前的进度
	const {projectInfo} = store.state;
	console.log(projectInfo);
	const {step} = projectInfo;
	if (step > 2) {
		router.replace({
			path: "/economic",
			query: {
				id: encryptData(loadId.value),
				step: encryptData(3),
			},
		});
	} else {
		saveScemeStep(loadId.value).then(res => {
			message.success("配储评估保存成功！");
			// 更新vuex中项目信息
			store.commit("updateProjectInfo", {
				id: loadId.value,
				step: 3,
			});
			// 更新store中的项目步骤
			currentStep.value = 2;
			store.commit("updateProjectStep", 2);
			setTimeout(() => {
				router.replace({
					path: "/economic",
					query: {
						id: encryptData(loadId.value),
					},
				});
			}, 100);
		});
	}
};

/* 数据处理 */
// 更新禁止输入状态
const updateInputDisableStatus = (val = false) => {
	// 获取step
	const {step} = store.state.projectInfo;
	let res = false;
	// 大于该步骤时，不允许修改任何参数
	if (step && step > 2) {
		res = true;
	} else {
		res = val;
	}
	inputDisabled.value = res;
};

// 只能输入整数
const integerInput = props => {
	// 将非数字字符替换为空
	let result = formState[props].replace(/\D/g, "");

	// 确保结果不超过100
	if (parseInt(result) > 100) {
		result = "100";
	}

	formState[props] = result;
};

// 最多两位小数
const inputChange = (props, length = 2) => {
	var isValid = /^\d+(\.\d{0,2})?$/.test(formState[props]);

	if (!isValid) {
		// 如果输入不符合要求，只保留有效的数字部分
		let validValue = "";
		if (length == 2) {
			validValue = formState[props].match(/^\d+(\.\d{0,2})?/);
		}
		if (length == 9) {
			validValue = formState[props].match(/^\d+(\.\d{0,9})?/);
		}
		formState[props] = validValue ? validValue[0] : "";
	}
};

const blur = props => {
	if (String(formState[props]).endsWith(".")) {
		formState[props] = String(formState[props]).slice(0, -1);
	}
};

// 颗粒度数据处理
const inputGranularityChange = props => {
	var isValid = /^\d+$/.test(granularity[props]);

	if (!isValid) {
		// 如果输入不符合要求，只保留有效的数字部分
		let validValue = "";
		validValue = granularity[props].match(/^\d+/);
		if (validValue) {
			granularity[props] = validValue;
		} else {
			granularity[props] = "";
			formState.granularity = undefined;
		}
	} else {
		if (granularity[props] == 0) {
			granularity[props] = "";
			formState.granularity = undefined;
		}
	}
};
const granularityBlur = props => {
	if (String(granularity[props]).endsWith(".")) {
		granularity[props] = String(granularity[props]).slice(0, -1);
	}
};

// 生成具体的数据
const mackDetailData = key => {
	// 获取固定策略还是预置策略
	const total = capacityState.totalData[capacityState.tactics];
	const {
		timesDayMean,
		typical,
		timeRanges,
		elecCompare,
		feeCompare,
		elecChargeTotal,
		elecChargeDayMean,
		elecDischargeTotal,
		elecDischargeDayMean,
		chargeCostTotal,
		chargeCostDayMean,
		dischargeIncomeTotal,
		dischargeIncomeDayMean,
		benefitTotal,
		benefitDayMean,
		days,
	} = total;
	detailData.benefitTotal = toFixed(benefitTotal, 4);
	detailData.timesDayMean = timesDayMean;
	detailData.days = days;
	// 生成展示数据
	presentDataObjects.value = {
		elecChargeTotal: toFixed(elecChargeTotal / 1000),
		elecChargeDayMean: toFixed(elecChargeDayMean),
		elecDischargeTotal: toFixed(elecDischargeTotal / 1000),
		elecDischargeDayMean: toFixed(elecDischargeDayMean),
		chargeCostTotal: toFixed(chargeCostTotal, 4),
		chargeCostDayMean: toFixed(chargeCostDayMean, 4),
		dischargeIncomeTotal: toFixed(dischargeIncomeTotal, 4),
		dischargeIncomeDayMean: toFixed(dischargeIncomeDayMean, 4),
		benefitTotal: toFixed(benefitTotal, 4),
		benefitDayMean: toFixed(benefitDayMean, 4),
		days,
	};

	// 生成列表
	let typicalList = [];
	Object.keys(typical).map((key, index) => {
		if (index === 0 && capacityState.load == undefined) {
			capacityState.load = key;
		}
		typicalList.push({
			name: key,
			value: key,
		});
	});
	// 生成列表
	loadList.value = typicalList;

	// 绘制总表有功功率
	mackPowOptions(typical, total, timeRanges);

	if (key == undefined) {
		// 绘制电量对比
		electricOptions.value = mackElecOptios(elecCompare, "MWh");
		console.log(`elec：`, electricOptions.value);
		// 绘制电费对比
		electricCostOptions.value = mackElecOptios(feeCompare, "万元");
		console.log(`elecCost：`, electricCostOptions.value);
	}
};

// 绘制总表有功功率
const mackPowOptions = (typical, total, timeRanges) => {
	console.log(typical, total, timeRanges);
	// 绘制总表有功功率图
	let x_data = [];
	let y_data1 = [],
		y_data2 = [];
	typical[capacityState.load].map(el => {
		x_data.push(el.time);
		y_data1.push(el ? toFixed(el.before, 2) : "-");
		y_data2.push(el ? toFixed(el.after, 2) : "-");
	});
	let allTimes = [...x_data];
	let markAreaData = [];

	timeRanges[capacityState.load].map(el => {
		allTimes.push(el.start);
		allTimes.push(el.end);
		markAreaData.push([
			{
				name: map[el.type],
				xAxis: el.start,
				itemStyle: {
					color:
						el.type == "sharp"
							? "rgba(197,202,213,0.6)"
							: el.type == "peak"
							? "rgba(197,202,213,0.5)"
							: el.type == "flat"
							? "rgba(197,202,213,0.4)"
							: el.type == "valley"
							? "rgba(197,202,213,0.3)"
							: "rgba(197,202,213,0.2)",
				},
			},
			{
				xAxis: el.end,
			},
		]);
	});
	let powOptions = {
		...JSON.parse(JSON.stringify(defaultOptions)),
		series: [
			{
				name: "需量限制",
				data: Array(x_data.length).fill(toFixed(total.demandLimit, 2)),
				type: "line",
				symbol: "none", // 去除圆点
				lineStyle: {
					type: "dashed",
					width: 2,
				},
			},
			{
				name: "配储前",
				data: y_data1,
				type: "line",
				symbol: "none", // 去除圆点
			},
			{
				name: "配储后",
				data: y_data2,
				type: "line",
				symbol: "none", // 去除圆点
			},
			{
				name: "scatter",
				type: "scatter",
				markArea: {
					data: markAreaData,
				},
			},
		],
	};

	powOptions.xAxis.data = [...new Set(allTimes)].sort();
	powOptions.yAxis.name = "总表有功功率/kW";
	powOptions.yAxis.nameTextStyle.padding = [0, 0, 5, 0];
	powOptions.color = ["#F40D0D", "#7C92BA", "#0082FC"];
	powOptions.legend.data = ["需量限制", "配储前", "配储后"];
	powOptions.tooltip = {
		trigger: "axis",
		formatter: params => {
			const seriesData1 = params[0];
			const seriesData2 = params[1];
			let str = `<span style='font-weight:600'>${seriesData1.name}</span>`;
			params.map(el => {
				str += ` <br> ${el.marker} ${el.seriesName}：${el.data} kW `;
			});
			return str;
		},
	};
	powerOptions.value = powOptions;
	console.log(`powOptions：`, powOptions);
};

/* 动画 */
// 加载动画
let startAnimation = () => {
	parser = new SVGAParser();
	const container = document.getElementById("svgaA");
	parser.load("/svga/loading.svga", videoItem => {
		player = new SVGAPlayer(container);
		player.setVideoItem(videoItem);
		player.startAnimation();
	});
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
</style>
